// Copyright (C) 2015 Minted Inc.
// All Rights Reserved
// CTAG:COMMUNITY:CHALLENGES

var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/underscore-1.8.2.min': '_'
})(this, function (m_module, Backbone, $, _) {

  'use strict';

  var M = m_module.M;
  M.Community = M.Community || {};
  M.Community.View = M.Community.View || {};

  /**
    * @class
    * M.Community.View.Challenge.Design
    * Description:
    *   The design class for challenge pages. Eventually, we want every
    *   design to be rendered by this view.
    *
    *
    */
  M.Community.View.Design = Backbone.View.extend({
   // js rendering for a single design is currently done in mako and not needed
   // in js.
  },{
    // TODO: addAwardIconToDesign create the awardIcon according to what
    // badge the winner has, define more trophy types as constants in the
    // future, and create the AwardIcon view accordingly

    /**
     * add award icon to one design
     * @designEl, object, the element that the award icon will be attached on.
     * @position, number, the position of the design in the challenge
     */
    addAwardIconToDesign: function(designEl, position) {
      var isEditorsPick = $(designEl).attr('is_editors_pick') === "true";
      var isFirstPlace = $(designEl).attr('is_first_place') === "true";
      var isSpecialPrizeWinner = $(designEl).attr('is_special_prize_winner') === "true";
      var type = M.Config.ChallengeConfig['winners_type']['winner'];
      if (isEditorsPick) {
        type = M.Config.ChallengeConfig['winners_type']['editors_pick'];
      }
      if (isFirstPlace) {
        type = M.Config.ChallengeConfig['winners_type']['first_place'];
      }
      if (isSpecialPrizeWinner) {
        type = M.Config.ChallengeConfig['winners_type']['special_prize_winner'];
      }
      var awardIcon = new M.Community.View.Challenge.AwardIcon({
        type: type,
      });

      $(designEl).find('.designImageBox').prepend(awardIcon.render().$el);
    },

  });

  return {};
});
